import { DateTime } from 'luxon';

export const renderDay = (date: string) => {
  const dt = DateTime.fromISO(date);
  const isToday = dt.hasSame(DateTime.now(), 'day');
  return (
    <div
      style={{
        background: isToday ? 'var(--mantine-color-blue-0)' : undefined,
        borderRadius: 'var(--mantine-radius-sm)',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {dt.day}
    </div>
  );
};
